var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import { fixedForwardRef } from './fixedForwardRef';
function OptionWithForwardRef(_a, ref) {
    var item = _a.item, isHighlighted = _a.isHighlighted, isSelected = _a.isSelected, children = _a.children, onMouseEnter = _a.onMouseEnter, onClick = _a.onClick, rest = __rest(_a, ["item", "isHighlighted", "isSelected", "children", "onMouseEnter", "onClick"]);
    var id = useId();
    return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("div", __assign({ id: id, role: "option", onMouseEnter: onMouseEnter, "aria-selected": isSelected, ref: ref, onClick: onClick, className: "ffe-searchable-dropdown__list-item-container" }, rest), children({
        item: item,
        isHighlighted: isHighlighted,
        isSelected: isSelected,
    })));
}
export var Option = fixedForwardRef(OptionWithForwardRef);
